import { ensureError } from '@passionware/platform-js';
import { SchemaError } from 'v4/entities/common/parseWithDecoratedError';

/** A schema failure carries the raw issue list as its message; show a readable line instead. */
export function saveErrorMessage(
  error: unknown,
  invalidDataMessage: string
): string {
  if (error instanceof SchemaError) return invalidDataMessage;
  return ensureError(error).message;
}
